import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Typography } from "@mui/material";
import { Button, Datagrid, FunctionField, TextField, useRecordContext } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { debtsRequests } from "api/debtsApi";
import { TransactionStatuses } from "utils/constants";
import { useNotifyError } from "utils/useNotifyError";
import { settings } from "app";

const TransactionsDialog = () => {
  const record = useRecordContext();
  const notifyError = useNotifyError();
  const [transactions, setTransactions] = useState([]);

  const onOpen = async () => {
    try {
      const { data } = await dataProvider.customRequest(debtsRequests.getDebtTransactions(record?.id), null, "GET");
      setTransactions(data ?? []);
    } catch (err) {
      notifyError(err);
      return false;
    }
  };

  return (
    <ConfirmModal
      titleContent="Транзакции по задължението"
      dialogSize="md"
      isConfirmButton={false}
      closeTitle="Затвори"
      onOpen={onOpen}
      resetProps={() => setTransactions([])}
      triggerButton={
        <Button
          label="Транзакции"
          startIcon={<VisibilityIcon />}
          size="small"
        />
      }
    >
      <Datagrid
        data={transactions}
        rowClick={false}
        bulkActionButtons={false}
        resource="debtTransactions"
        empty={<Typography sx={{ p: 2 }}>Няма транзакции</Typography>}
        sx={{ ...settings.style.secondaryDatagrid, m: 2 }}
      >
        <TextField
          label="Номер"
          source="id"
          emptyText="-"
          sortable={false}
        />
        <TextField
          label="Вид плащане"
          source="providerName"
          emptyText="-"
          sortable={false}
        />
        <FunctionField
          label="Сума"
          sortable={false}
          render={rec => `${Number(rec?.amount ?? 0).toFixed(2)} ${rec?.currency ?? ""}`.trim()}
        />
        <FunctionField
          label="Статус"
          sortable={false}
          render={rec => TransactionStatuses[rec?.status] || rec?.status || "-"}
        />
      </Datagrid>
    </ConfirmModal>
  );
};

export default TransactionsDialog;
